import CardCommunications from "./card-communications";

export default CardCommunications;
